export default class Footer {
    constructor() {
        this.header = document.querySelector('header');
        this.footer = document.querySelector('footer');
        this.footerMenu = this.footer.querySelector('.footer-menu');
        this.toggleItems = this.footerMenu.querySelectorAll('[data-footer-menu]');
        this.toTopButton = this.footer.querySelector('.btn-to-top');
        this.toTopButtonAlt = this.footer.querySelector('.btn-to-top.alt');
        this.headerBottom = this.header.offsetHeight;
        this.lastScrollTop = 0;
        this.isButtonVisible = false;
        this.scrollingUp = false;
        this.addEventListeners();
    }
    addEventListeners() {
        if (this.toggleItems) {
            this.toggleItems.forEach((toggleItem) => {
                toggleItem.addEventListener('click', (event) => {
                    event.preventDefault();
                    const parent = toggleItem.parentElement;
                    parent.classList.toggle('is-active');
                    this.handleToggle(parent);
                });
            });
        }
        this.toTopButton.addEventListener('click', (event) => this.scrollToTop());
        this.toTopButtonAlt.addEventListener('click', (event) => this.scrollToTop());
        window.addEventListener('scroll', () => {
            let windowTop = window.scrollY;
            let isScrollingUp = windowTop < this.lastScrollTop;
            if (window.scrollY === 0) {
                this.scrollingUp = false;
            }
            // show button if scrolling up and past header
            if (!this.scrollingUp && isScrollingUp && windowTop > this.headerBottom && !this.isButtonVisible) {
                this.toTopButtonAlt.classList.add('is-visible');
                this.isButtonVisible = true;
            }
            // hide button if scrolling down or above header
            else if ((!isScrollingUp || windowTop <= this.headerBottom) && this.isButtonVisible) {
                this.toTopButtonAlt.classList.remove('is-visible');
                this.isButtonVisible = false;
            }
            this.lastScrollTop = windowTop; // update last scroll position
        });
    }
    handleToggle(parent) {
        this.toggleItems.forEach((toggleItem) => {
            if (toggleItem.parentElement !== parent) {
                toggleItem.parentElement.classList.remove('is-active');
            }
        });
    }
    scrollToTop() {
        this.scrollingUp = true;
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}
